import { render, staticRenderFns } from "./new-task-button.vue?vue&type=template&id=fcd1d8c2&"
import script from "./new-task-button.vue?vue&type=script&lang=ts&"
export * from "./new-task-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports